// extracted by mini-css-extract-plugin
export default {"staticBackground":"BrandedBackground_staticBackground__l5124","background":"BrandedBackground_background__xaaa9","foreground":"BrandedBackground_foreground__N7X8S"};